import { ConditionalTooltipWrapper } from 'components/Tooltip';
import React from 'react';
import { Badge, Button } from 'reactstrap';

import './styles.css';

type Props = {
  id: string;
  onClick: () => void;
  tooltip?: React.ReactNode;
  tooltipPlacement?: 'top' | 'bottom' | 'right' | 'left';
  disabled?: boolean;
  active?: boolean;
  stale?: boolean;
  size?: 'sm' | 'lg';
  cssClass?: string;
  iconClass?: string;
  iconElement?: JSX.Element;
  countBadge?: number;
};

function IconButton({
  id,
  iconClass,
  tooltip,
  size = 'lg',
  disabled = false,
  active = false,
  stale = false,
  onClick,
  cssClass,
  iconElement,
  countBadge,
}: Props) {
  return (
    <div style={{ position: 'relative' }} className="d-inline">
      <div className="d-inline">
        <ConditionalTooltipWrapper tooltip={tooltip}>
          <Button
            id={id}
            color={size === 'sm' ? 'c1' : 'c2'}
            size="sm"
            className={`mt-0 ${active ? cssClass + ' active' : ''}${
              disabled ? ' disabled' : ''
            }`}
            disabled={disabled}
            onClick={onClick}
          >
            {iconClass && <i className={iconClass}></i>}
            {iconElement !== undefined && iconElement}
          </Button>
        </ConditionalTooltipWrapper>
      </div>
      {countBadge && countBadge > 0 ? (
        <Badge
          color="transparent"
          pill
          style={{
            position: 'absolute',
            top: '-7px',
            right: '-6px',
            fontSize: '0.70rem',
            color: '#fff',
            textShadow:
              '-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black',
            cursor: 'pointer',
          }}
          // className="p-1"
          onClick={onClick}
        >
          {countBadge}
        </Badge>
      ) : null}
    </div>
  );
}

export default IconButton;
